import { IMapControlParam } from '@/types/map'

declare const BMapGL: any;

declare const BMAP_ANCHOR_TOP_LEFT: any;
declare const BMAP_ANCHOR_BOTTOM_LEFT: any;
declare const BMAP_ANCHOR_TOP_RIGHT: any;
declare const BMAP_ANCHOR_BOTTOM_RIGHT: any;

//地图比例尺控件
export class ZoomControlBD {
    private static instances: Map<string, any>;//一个BMap.Map对应一个Control
    private view: any;
    private control: any;//控件
    private visible: boolean;
    private anchor: string;//"top-left"\"top-right"\"bottom-left"\"bottom-right"
    private xoffset: number;
    private yoffset: number;

    constructor(view: any) {
        this.view = view;
        this.visible = false;
        this.anchor = "bottom-left";
        this.xoffset = 0;
        this.yoffset = 0;
        this.control = undefined;
    }

    public static getInstance(view: any): ZoomControlBD {
        let id = view.getContainer().id;
        if (!ZoomControlBD.instances) {
            ZoomControlBD.instances = new Map();
        }
        let instance = ZoomControlBD.instances.get(id);
        //若没有view对应的实例，则重新创建一个
        if (!instance) {
            instance = new ZoomControlBD(view);
            ZoomControlBD.instances.set(id, instance);
        }
        return instance;
    }

    public async set(params: IMapControlParam) {
        if (!this.view) {
            //地图未创建，直接返回
            return;
        }
        let isRemove: boolean = params.options?.remove || false;
        if (isRemove) {
            this._remove();
            return;
        }
        if (!this.control) {
            //为地图添加一个比例尺控件
            let control = new BMapGL.ZoomControl();
            this.view.addControl(control);
            this.control = control;
            // this.view.addControl(this.control);
        }
        this.visible = params.visible || false;
        await this._setVisible();
        this.anchor = params.anchor || "bottom-left";
        await this._setAnchor();
        this.xoffset = params.options?.xoffset || 0;
        this.yoffset = params.options?.yoffset || 0;
        await this._setOffset();
    }

    //删除自身
    private async _remove() {
        if (!this.view) {
            return;
        }
        let id = this.view.getContainer().id;
        ZoomControlBD.instances.delete(id);
        this.view.removeControl(this.control);
        this.control = undefined;
        this.view == null;
    }

    //设置锚点
    private async _setAnchor() {
        let ca: string;
        switch (this.anchor) {
            case "top-left":
                ca = BMAP_ANCHOR_TOP_LEFT;
                break;
            case "top-right":
                ca = BMAP_ANCHOR_TOP_RIGHT;
                break;
            case "bottom-right":
                ca = BMAP_ANCHOR_BOTTOM_RIGHT;
                break;
            case "bottom-left":
            default:
                ca = BMAP_ANCHOR_BOTTOM_LEFT;
                break;
        }
        this.control.setAnchor(ca);
    }

    //设置偏移
    private async _setOffset() {
        this.control.setOffset(new BMapGL.Size(this.xoffset, this.yoffset));
    }

    //设置是否可见
    private async _setVisible() {
        if (this.visible) {
            this.control.show();
        } else {
            this.control.hide();
        }
    }
};